// Маппинг Unicode emoji → имя файла Google Noto Animated Emoji (WebP)
// Локальные файлы размещаются в: /content/themes/linda2/static/images/emoji-animated/
// Формат имени файла: {codepoint}.webp (нижний регистр, codepoints через '_')

const EMOJI_ANIMATED_BASE = '/content/themes/linda2/static/images/emoji-animated/';

// Карта: Unicode-строка → имя файла (без расширения)
const EMOJI_FILE_MAP: Record<string, string> = {
  '❤️': '2764',
  '😂': '1f602',
  '👍': '1f44d',
  '😮': '1f62e',
  '😢': '1f622',
  '🔥': '1f525',
  // ... расширить по мере добавления WebP
};

// Автогенерация имени файла для emoji, которого нет в карте
function codepointsToFilename(emoji: string): string | null {
  // Разбить emoji на codepoints, преобразовать каждый в HEX
  // Склеить через _, удалить Variation Selector (FE0F)
  const codepoints: string[] = [];
  for (const ch of emoji) {
    const cp = ch.codePointAt(0);
    if (cp === undefined) continue;
    if (cp === 0xFE0F) continue; // VS16 — Noto не использует в именах
    codepoints.push(cp.toString(16).padStart(4, '0'));
  }
  if (codepoints.length === 0) return null;
  return codepoints.join('_');
}

export function emojiToAnimatedUrl(emoji: string): string | null {
  const filename = EMOJI_FILE_MAP[emoji] || codepointsToFilename(emoji);
  if (!filename) return null;
  return `${EMOJI_ANIMATED_BASE}${filename}.webp`;
}

// Обратная совместимость: старые названия алиасы на WebP
export function emojiToSvgUrl(emoji: string): string | null {
  return emojiToAnimatedUrl(emoji);
}

export function hasAnimatedEmoji(emoji: string): boolean {
  return emoji in EMOJI_FILE_MAP;
}

// Обратная совместимость
export function hasAnimatedSvg(emoji: string): boolean {
  return hasAnimatedEmoji(emoji);
}
